import React from 'react';
import { FaCalendarAlt, FaComments, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import './StatsCards.scss';

// Helper function to lighten a hex color
const lightenColor = (color, percent = 85) => {
    const num = parseInt(color.replace('#', ''), 16);
    const r = (num >> 16) + Math.round((255 - (num >> 16)) * (percent / 100));
    const g = ((num >> 8) & 0x00FF) + Math.round((255 - ((num >> 8) & 0x00FF)) * (percent / 100));
    const b = (num & 0x0000FF) + Math.round((255 - (num & 0x0000FF)) * (percent / 100));
    return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
};

const StatsCards = ({ stats }) => {
    if (!stats) {
        return (
            <div className="stats-cards">
                <div className="stats-card stats-card--loading">
                    <div className="loading-placeholder"></div>
                </div>
                <div className="stats-card stats-card--loading">
                    <div className="loading-placeholder"></div>
                </div>
                <div className="stats-card stats-card--loading">
                    <div className="loading-placeholder"></div>
                </div>
                <div className="stats-card stats-card--loading">
                    <div className="loading-placeholder"></div>
                </div>
            </div>
        );
    }

    const cards = [
        {
            title: 'Upcoming Appointments',
            value: stats.upcomingAppointments || 0,
            icon: FaCalendarAlt,
            color: '#3498db',
            description: 'Scheduled appointments'
        },
        {
            title: 'Pending Messages',
            value: stats.pendingMessages || 0,
            icon: FaComments,
            color: '#f39c12',
            description: 'Unread customer replies'
        },
        {
            title: 'Confirmed',
            value: stats.conversations?.confirmed || 0,
            icon: FaCheckCircle,
            color: '#27ae60',
            description: 'Confirmed appointments'
        },
        {
            title: 'Need Reschedule',
            value: stats.conversations?.needs_reschedule || 0,
            icon: FaExclamationTriangle,
            color: '#e67e22',
            description: 'Require rescheduling'
        }
    ];

    return (
        <div className="stats-cards">
            {cards.map((card, index) => {
                const IconComponent = card.icon;
                return (
                    <div key={index} className="stats-card">
                        <div className="stats-card__icon" style={{
                            backgroundColor: lightenColor(card.color, 85),
                            color: card.color
                        }}>
                            <IconComponent />
                        </div>
                        <div className="stats-card__content">
                            <div className="stats-card__value">{card.value}</div>
                            <div className="stats-card__title">{card.title}</div>
                            <div className="stats-card__description">{card.description}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StatsCards;